import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    const saved = localStorage.getItem("theme")

    if (saved) {
      this.setTheme(saved)
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      this.setTheme(prefersDark ? "dark" : "light")
    }

    // Load Bootstrap tab
    const hash = window.location.hash;
    if (hash) {
      const triggerElement = document.querySelector(`#pageTabs button[data-bs-target="${hash}"]`);
      if (triggerElement) {
        new Tab(triggerElement).show();
      }
    }
  }

  toggle() {
    const current = document.documentElement.getAttribute("data-bs-theme")
    const next = current === "dark" ? "light" : "dark"

    this.setTheme(next)
    localStorage.setItem("theme", next)
  }

  setTheme(theme) {
    document.documentElement.setAttribute("data-bs-theme", theme)

    if (this.hasIconTarget) {
      this.iconTarget.textContent = theme === "dark" ? "🌙" : "☀️"
    }
  }
}